import * as React from 'react';

import './Spinner.css';

export default function Spinner(): JSX.Element {
  return (
    <div className="spinner"/>
  );
}
